// src/store/api/userApi.ts
import { User } from '@/types';
import { apiSlice } from './apiSlice';

export interface UpdateAdminPayload {
  firstname?: string;
  lastname?: string;
  dialCode?: string;
  mobile?: string;
  profileImage?: string | null;
  country?: string;
  eoa?: string;
}

export const userApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // ✅ GET profile
    getUserProfile: builder.query<User, void>({
      query: () => '/users/me',
      providesTags: ['User'],
    }),

    // ✅ PATCH profile
    updateUserProfile: builder.mutation<void, UpdateAdminPayload>({
      query: (body) => ({
        url: '/users/me',
        method: 'PATCH',
        body,
      }),
      invalidatesTags: ['User'],
    }),

    changePassword: builder.mutation<void, { oldPassword: string; newPassword: string }>({
      query: (body) => ({
        url: '/admin/change-password',
        method: 'POST',
        body,
      }),
    }),
    changeProfileImage: builder.mutation<{ profileImage: string }, { profileImage: string }>({
      query: (body) => ({
        url: '/admin/profile-image',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['User'],
    }),
  }),
});

export const {
  useGetUserProfileQuery,
  useLazyGetUserProfileQuery,
  useUpdateUserProfileMutation,
  useChangePasswordMutation,
  useChangeProfileImageMutation,
} = userApi;
